const config = {
  dev: false,
};

export default config;
